const queryParams = (new URL(document.location.href)).searchParams

const attributes = {}
queryParams.forEach(function(value, key) {
    if(key.indexOf('filter_') === 0) {
        attributes[key] = value
    }
});

export default () => ({
    app: {
        loading: false,
        orderProduct: null,
        openModal: null,
    },

    filters: {...{
            orderBy: queryParams.get('orderBy') || '',
            perPage: Number(queryParams.get('perPage')) || 24,
            page: Number(queryParams.get('page')) || 1,
            search: queryParams.get('search') || null,
        }, ...attributes},
})
